import React from "react";
import { useHistory } from "react-router-dom";
//Style
import {
  Back,
  BackContainer,
  Container,
  Content,
  Header,
  Label,
  Value,
} from "./style";
const JumBotron = ({ serial, name, state, remaining, isRejected }) => {
  const STEPS = !isRejected
    ? ["Ingresado", "Tramite", "Cerrado"]
    : ["Ingresado", "Cerrado"];
  const history = useHistory();
  return (
    <Container>
      <Header>
        <BackContainer
          onClick={() => {
            history.replace("/");
          }}
        >
          <Back>{"<"}</Back>
          Regresar
        </BackContainer>
      </Header>
      <Content>
        <Label>
          Solicitante:
          <Value>{name}</Value>
        </Label>
        <Label>
          Número de consecutivo:
          <Value>{serial}</Value>
        </Label>
        <Label>
          Estado actual:
          <Value>{STEPS[state]}</Value>
        </Label>
        <Label>
          Tiempo restante de respuesta:
          <Value>{remaining} Días</Value>
        </Label>
      </Content>
    </Container>
  );
};

export default JumBotron;
